import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  KernCheckbox,
  KernRadio,
  KernSelect,
  KernText,
  KernTextarea,
} from './fields';

const field = (
  name: string,
  component: Parameters<typeof createFormField>[0]['component'],
) =>
  FormFieldBlueprint.make({
    name: name.toLowerCase(),
    params: {
      field: async () => createFormField({ name, component }),
    },
  });

/**
 * Provides the KERN form fields for software templates.
 * Usage in a template: `ui:field: KernText`.
 */
export const scaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    field('KernText', KernText),
    field('KernTextarea', KernTextarea),
    field('KernSelect', KernSelect),
    field('KernCheckbox', KernCheckbox),
    field('KernRadio', KernRadio),
  ],
});
